import React from "react"
import { css, jsx } from "@emotion/core"

class SidebarWrapper extends React.Component {
  render() {
    return (
      <aside
        css={{
          position: "relative",
          width: "360px",
          marginLeft: "-380px",
          float: "right",
          overflow: "hidden",
          minHeight: this.props.minHeight || "600px",
          padding: "2px",
          "@media(max-width: 1299px)": {
            display: "none",
          },
        }}
      >
        {this.props.children}
      </aside>
    )
  }
}

export default SidebarWrapper
